const PulseDot = ({ status = 'online', size = 'sm', className = '' }) => {
  const colors = {
    online: 'bg-success',
    warning: 'bg-warning',
    error: 'bg-error',
    offline: 'bg-steel-muted',
  };
  const sizes = { sm: 'w-2 h-2', md: 'w-3 h-3', lg: 'w-4 h-4' };

  return (
    <span className={`relative inline-flex ${className}`} role="status" aria-label={`Status: ${status}`}>
      <span className={`${sizes[size]} rounded-full ${colors[status]}`} />
      {status === 'online' && (
        <span className={`absolute inset-0 ${sizes[size]} rounded-full ${colors[status]} animate-ping opacity-75`} />
      )}
    </span>
  );
};

export default PulseDot;
